import React from 'react';
import * as Yup from 'yup';
import { BiImageAdd } from 'react-icons/bi';

import FileInput from '../../../../../../newComponents/FileInput';

import { usePizzaProduct } from '../../../../../../hooks/pizzaProduct';

import { Container } from './styles';

export const ImagesFormSchema = Yup.object().shape({});

const Images: React.FC = () => {
  const { images, handleChangeImage } = usePizzaProduct();

  return (
    <Container>
      {images.map((image, index) => (
        <FileInput
          id={`pizzaProductImage-${index}`}
          icon={BiImageAdd}
          title={`Imagem ${index + 1}`}
          selectedImage={image?.file}
          acceptableTypes=".jpeg,.jpg,.png"
          subtitle="Formatos: .jpeg, .jpg, .png"
          onRemove={() => handleChangeImage(index, undefined)}
          onSelectFile={(imageToChange) =>
            handleChangeImage(index, imageToChange)
          }
        />
      ))}
    </Container>
  );
};

export default Images;
